import React, { useEffect, useState } from 'react';
import {
    View,
    Text,
    ActivityIndicator,
    StyleSheet,
    Image,
    ScrollView,
    TouchableOpacity,
    Modal,
    Linking,
    Alert,
} from 'react-native';
import mystyles from '../../assets/styles/mystyles';
import { callApi, getUserId } from '../Helper/Helper';
import {SafeAreaView} from 'react-native-safe-area-context';

const ProviderDetails = ({ route }) => {
    const { pUserId } = route.params;
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [foodServices, setFoodServices] = useState(null);
    const [loadingFood, setLoadingFood] = useState(false);
    const [houseHoldServices, setHouseholdServices] = useState(null);
    const [loadingHousehold, setLoadingHousehold] = useState(false);
    const [transportServices, setTransportServices] = useState(null);
    const [loadingTransport, setLoadingTransport] = useState(false);
    const [activeSection, setActiveSection] = useState('FOOD');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [averageRating, setAverageRating] = useState(0);

            const [alertVisible, setAlertVisible] = useState(false);
            const [alertMessage, setAlertMessage] = useState('');
        const [alertType, setAlertType] = useState('success'); // 'success' or 'error'

        const fetchRatings = async () => {
          try {
            const ratingData = await callApi('GET', `/eabu-get-user-ratings/${pUserId}`);
            if (ratingData) {
              setAverageRating(ratingData.averageRating);
            }
          } catch (e) {
            console.error('Error fetching ratings:', e);
          }
        };

        useEffect(() => {
          const fetchDetails = async () => {
          try {
            // Assuming the API expects a query param or similar structure based on endpoint name
            const json = await callApi('GET', '/eabu-user/'+ pUserId);
            setDetails(json);
              } catch (e) {
                setError(e);
              } finally {
            setLoading(false);
          }
        };

        fetchDetails();
        fetchRatings();
      }, [pUserId]);

        function headerLabel(col) {
            switch (col) {
            case 'title':
                return 'Service';
            case 'description':
                return 'Details';
            default:
                return col;
        }
    }

    const SERVICE_COLORS = {
        FOOD: '#FF9800',
        HOUSEHOLD: '#4CAF50',
        TRANSPORT: '#2196F3',
    };

    const SERVICE_OPTIONS = [
        { label: 'Food Service', value: 'FOOD', color: SERVICE_COLORS.FOOD },
        { label: 'Household Help', value: 'HOUSEHOLD', color: SERVICE_COLORS.HOUSEHOLD },
        { label: 'Moving & Transport', value: 'TRANSPORT', color: SERVICE_COLORS.TRANSPORT },
    ];

    useEffect(() => {
        if (activeSection === 'FOOD') handleFoodServiceClick();
    }, []);

    const handleServiceChange = (value) => {
        setActiveSection(value);
        setIsDropdownOpen(false);

        if (value === 'FOOD') handleFoodServiceClick();
        else if (value === 'HOUSEHOLD') handleHouseholdHelpClick();
        else if (value === 'TRANSPORT') handleMoveAndTransportClick();
    };

    const handleFoodServiceClick = async () => {
        // setActiveSection('FOOD');
        if (foodServices) return;

        setLoadingFood(true);
        try {
            const data = await callApi('GET', `/provider-my-eat-services/${pUserId}`);
            setFoodServices(data);
        } catch (e) {
            console.error('Error fetching food services:', e);
        } finally {
            setLoadingFood(false);
        }
    };

    const handleHouseholdHelpClick = async () => {
        // setActiveSection('HOUSEHOLD');
        if (houseHoldServices) return;

        setLoadingHousehold(true);
        try {
            const data = await callApi('GET', `/provider-my-live-services/${pUserId}`);
            setHouseholdServices(data);
        } catch (e) {
            console.error('Error fetching Household services:', e);
        } finally {
            setLoadingHousehold(false);
        }
    };

    const handleMoveAndTransportClick = async () => {
        // setActiveSection('TRANSPORT');
        if (transportServices) return;

        setLoadingTransport(true);
        try {
            const data = await callApi('GET', `/provider-my-move-services/${pUserId}`);
            setTransportServices(data);
        } catch (e) {
            console.error('Error fetching Household services:', e);
        } finally {
            setLoadingTransport(false);
        }
    };


    const handleRateService = async (item, starsSelected) => {
        let category = '';
        if (activeSection === 'FOOD') category = 'eat';
        else if (activeSection === 'HOUSEHOLD') category = 'live';
        else if (activeSection === 'TRANSPORT') category = 'move';

        const cUserId = await getUserId();

        const payload = {
            zipcode: item.zipcode,
            ID: item.ID,
            totalstars: (Number(item.totalstars) || 0) + starsSelected,
            ratingscount: (Number(item.ratingscount) || 0) + 1,
            providerType: category,
            cUserId: cUserId,
        };

        try {
            const response = await callApi('POST', '/eabu-update-ratings', {body: payload});
            setAlertMessage(response.message || 'Rating submitted successfully');
            setAlertType('success');
            setAlertVisible(true);
                fetchRatings();
            } catch (e) {
                console.error('Error submitting rating:', e);
                setAlertMessage('Failed to submit rating');
            setAlertType('error');
            setAlertVisible(true);
        }
    };



    const handleReport = () => {
        const subject = encodeURIComponent(`Report — eabu (provider: ${pUserId})`);
        const body = encodeURIComponent(
            'Please describe the issue you are reporting (inappropriate content, unsafe behavior, etc.):\n\n'
        );
        const mailtoUrl = `mailto:daspenns@gmail.com?subject=${subject}&body=${body}`;

        Linking.openURL(mailtoUrl).catch(() => {
            Alert.alert(
                'Unable to open email app',
                'Please email daspenns@gmail.com directly to report this provider or any content in the app.'
            );
        });
    };

    if (loading) {
        return (
            <View style={[mystyles.container, mystyles.center]}>
                <ActivityIndicator size="large" color="#0000ff" />
            </View>
        );
    }

    if (error) {
        return (
            <View style={[mystyles.container, mystyles.center]}>
                <Text style={mystyles.errorText}>Error loading details.</Text>
            </View>
        );
    }

    const renderServices = () => {
        const services = details?.services || [];
        if (!services.length) return <Text>No services listed.</Text>;

        return services.map((svc, index) => (
            <View key={index} style={styles.serviceTag}>
                <Text style={styles.serviceText}>{svc}</Text>
            </View>
        ));
    };

    const renderServiceCards = (data, isLoading, emptyMsg, themeColor) => {
        if (isLoading) {
            return (
                <ActivityIndicator
                    size="small"
                    color={themeColor}
                    style={{ marginTop: 15 }}
                />
            );
        }

        if (!data) return null;

        const items = data.Items || [];

        if (items.length === 0) {
            return (
                <View style={styles.noDataContainer}>
                    <Text style={styles.noDataText}>{emptyMsg}</Text>
                </View>
            );
        }

        return (
            <View style={styles.cardsList}>
                {items.map((item, index) => (
                    <View
                        key={index}
                        style={[styles.cardItem, { borderLeftColor: themeColor }]}>
                        <View style={styles.cardHeader}>
                            <Text style={styles.cardTitle}>{item.title || 'N/A'}</Text>
                            <View style={styles.ratingBadge}>
                                <Text style={styles.ratingText}>
                                    {item.ratingscount > 0
                                        ? (item.totalstars / item.ratingscount).toFixed(1)
                                        : '0.0'}
                                </Text>
                                <Text style={styles.starIcon}>★</Text>
                            </View>
                        </View>
                        <Text style={styles.cardDescription}>
                            {item.description || '-'}
                        </Text>
                        <View style={styles.cardFooter}>
                            <Text style={styles.footerLabel}>Rate:</Text>
                            <View style={styles.starRow}>
                                {[1, 2, 3, 4, 5].map(star => (
                                    <TouchableOpacity
                                        key={star}
                                        onPress={() => handleRateService(item, star)}
                                        style={styles.starTouch}>
                                        <Text style={{ color: themeColor, fontSize: 20 }}>
                                            ★
                                        </Text>
                                    </TouchableOpacity>
                                ))}
                            </View>
                        </View>
                    </View>
                ))}
            </View>
        );
    };

    return (
        <SafeAreaView style={styles.container}>
            <ScrollView contentContainerStyle={styles.content}>
                <View style={mystyles.card}>
                    <View style={styles.header}>
                        {details?.profilePicture ? (
                            <Image
                                source={{ uri: details.profilePicture }}
                                style={styles.profileImage}
                            />
                        ) : (
                            <View style={styles.infoCard}>
                                <Text style={styles.providerName}>{pUserId}</Text>
                                <Text style={styles.ratingLabel}>Overall rating</Text>
                                <View style={styles.ratingRow}>
                                    <Text style={styles.starIconMain}>★</Text>
                                    <Text style={styles.ratingValue}>
                                        {typeof averageRating === 'number'
                                            ? averageRating.toFixed(1)
                                            : averageRating || '0.0'}
                                    </Text>
                                </View>
                            </View>
                        )}

                    </View>

                    <TouchableOpacity style={styles.reportButton} onPress={handleReport}>
                        <Text style={styles.reportButtonText}>⚑ Report this provider</Text>
                    </TouchableOpacity>

                    {details?.url ? (
                        <View style={styles.section}>

                            <Image
                                source={{ uri: details.url }}
                                style={styles.contentImage}
                                resizeMode="cover"
                            />
                        </View>
                    ) : null}

                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>Services Provided:</Text>

                        <View style={styles.dropdownContainer}>
                            <TouchableOpacity
                                style={styles.dropdownButton}
                                onPress={() => setIsDropdownOpen(!isDropdownOpen)}
                            >
                                <Text style={styles.dropdownButtonText}>
                                    {SERVICE_OPTIONS.find(opt => opt.value === activeSection)?.label || 'Select Service'}
                                </Text>
                                <Text style={styles.dropdownArrow}>▼</Text>
                            </TouchableOpacity>

                            {isDropdownOpen && (
                                <View style={styles.dropdownList}>
                                    {SERVICE_OPTIONS.map((option) => (
                                        <TouchableOpacity
                                            key={option.value}
                                            style={[
                                                styles.dropdownItem,
                                                activeSection === option.value && styles.dropdownItemSelected
                                            ]}
                                            onPress={() => handleServiceChange(option.value)}
                                        >
                                            <View style={[styles.colorDot, { backgroundColor: option.color }]} />
                                            <Text style={styles.dropdownItemText}>{option.label}</Text>
                                        </TouchableOpacity>
                                    ))}
                                </View>
                            )}
                        </View>

                        {activeSection === 'FOOD' &&
                            renderServiceCards(
                                foodServices,
                                loadingFood,
                                'No food services available.',
                                SERVICE_COLORS.FOOD,
                            )}

                        {activeSection === 'HOUSEHOLD' &&
                            renderServiceCards(
                                houseHoldServices,
                                loadingHousehold,
                                'No household services available.',
                                SERVICE_COLORS.HOUSEHOLD,
                            )}

                        {activeSection === 'TRANSPORT' &&
                            renderServiceCards(
                                transportServices,
                                loadingTransport,
                                'No transport services available.',
                                SERVICE_COLORS.TRANSPORT,
                            )}
                    </View>
                </View>
            </ScrollView>

            <Modal
                animationType="fade"
                transparent={true}
                visible={alertVisible}
                onRequestClose={() => setAlertVisible(false)}>
                <View style={styles.centeredView}>
                    <View style={styles.modalView}>
                        <Text
                            style={[
                                styles.modalTitle,
                                { color: alertType === 'success' ? '#4CAF50' : '#F44336' },
                            ]}>
                            {alertMessage === 'You already rated this item'
                                ? 'uh-oh'
                                : alertType === 'success'
                                    ? 'Success!'
                                    : 'Error'}
                        </Text>
                        <Text style={styles.modalText}>{alertMessage}</Text>
                        <TouchableOpacity
                            style={[
                                styles.button,
                                { backgroundColor: alertType === 'success' ? '#4CAF50' : '#F44336' },
                            ]}
                            onPress={() => setAlertVisible(false)}>
                            <Text style={styles.textStyle}>OK</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>
        </SafeAreaView>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 16,
    },
    content: {
        paddingBottom: 20,
    },
      header: {
        alignItems: 'center',
        marginBottom: 20,
      },
      profileImage: {
        width: 50,
        height: 50,
        borderRadius: 25,
        marginBottom: 10,
      },
      largeAvatar: {
        width: 100,
        height: 100,
        borderRadius: 50,
        marginBottom: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    section: {
        marginTop: 15,
    },
    sectionTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    servicesContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    serviceTag: {
        backgroundColor: '#e0e0e0',
        borderRadius: 15,
        paddingHorizontal: 10,
        paddingVertical: 5,
        marginRight: 5,
        marginBottom: 5,
    },
    serviceText: {
        fontSize: 14,
    },
    serviceButton: {
        backgroundColor: '#4A90E2',
        paddingVertical: 10,
        paddingHorizontal: 15,
        borderRadius: 20,
        marginRight: 10,
        marginBottom: 10,
        elevation: 3, // Android shadow
        shadowColor: '#000', // iOS shadow
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 3,
    },
    serviceButtonText: {
        color: '#fff',
        fontWeight: '600',
        fontSize: 14,
    },
    dropdownContainer: {
        marginBottom: 15,
        position: 'relative',
        zIndex: 100,
    },
    dropdownButton: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#fff',
        borderWidth: 1,
        borderColor: '#ccc',
        borderRadius: 8,
        paddingHorizontal: 15,
        paddingVertical: 12,
    },
    dropdownButtonText: {
        fontSize: 16,
        color: '#333',
    },
    dropdownArrow: {
        fontSize: 12,
        color: '#666',
    },
    dropdownList: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        borderWidth: 1,
        borderColor: '#ccc',
        borderRadius: 8,
        marginTop: 5,
        elevation: 10,
        zIndex: 1000,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.3,
        shadowRadius: 4,
    },
    dropdownItem: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 12,
        paddingHorizontal: 15,
        borderBottomWidth: 1,
        borderBottomColor: '#f0f0f0',
    },
    dropdownItemSelected: {
        backgroundColor: '#f0f8ff',
    },
    dropdownItemText: {
        fontSize: 16,
        color: '#333',
    },
    colorDot: {
        width: 10,
        height: 10,
        borderRadius: 5,
        marginRight: 10,
    },
    contentImage: {
        width: '100%',
        height: 200,
        marginTop: 10,
        borderRadius: 8,
    },
    cardsList: {
        marginTop: 15,
        zIndex: 1,
    },
    cardItem: {
        backgroundColor: '#fff',
        borderRadius: 8,
        padding: 15,
        marginBottom: 15,
        elevation: 2,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.2,
        shadowRadius: 2,
        borderLeftWidth: 5,
    },
    cardHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 8,
    },
    cardTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#333',
        flex: 1,
    },
    ratingBadge: {
        flexDirection: 'row',
        backgroundColor: '#f0f0f0',
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 12,
        alignItems: 'center',
    },
    ratingText: {
        fontWeight: 'bold',
        fontSize: 14,
        color: '#333',
        marginRight: 4,
    },
    starIcon: {
        fontSize: 12,
        color: '#FFC107',
    },
    cardDescription: {
        fontSize: 14,
        color: '#666',
        marginBottom: 12,
        lineHeight: 20,
    },
    cardFooter: {
        borderTopWidth: 1,
        borderTopColor: '#eee',
        paddingTop: 10,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    footerLabel: {
        fontSize: 12,
        color: '#888',
        marginRight: 10,
    },
    starRow: {
        flexDirection: 'row',
    },
    starTouch: {
        paddingHorizontal: 4,
    },
    noDataContainer: {
        marginTop: 20,
        alignItems: 'center',
    },
    noDataText: {
        fontSize: 14,
        color: '#777',
        fontStyle: 'italic',
    },
    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)',
    },
    modalView: {
        margin: 20,
        backgroundColor: 'white',
        borderRadius: 20,
        padding: 35,
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        minWidth: 250,
    },
    button: {
        borderRadius: 20,
        padding: 10,
        elevation: 2,
        marginTop: 15,
        minWidth: 100,
        alignItems: 'center',
    },
    textStyle: {
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    modalText: {
        marginBottom: 15,
        textAlign: 'center',
        fontSize: 16,
        color: '#333',
    },
    modalTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 10,
    },
    infoCard: {
        alignItems: 'center',
        marginTop: 5,
    },
    providerName: {
        fontSize: 24,
        fontWeight: '800',
        color: '#2c3e50',
        marginBottom: 10,
        textTransform: 'capitalize',
        letterSpacing: 0.5,
        textShadowColor: 'rgba(0, 0, 0, 0.05)',
        textShadowOffset: { width: 1, height: 1 },
        textShadowRadius: 2,
    },
    ratingRow: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#fff',
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 25,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 3,
        borderWidth: 1,
        borderColor: '#f0f0f0',
    },
    starIconMain: {
        fontSize: 20,
        color: '#FFC107',
        marginRight: 6,
        marginTop: -2,
    },
    ratingValue: {
        fontSize: 18,
        fontWeight: '700',
        color: '#333',
    },
    reportButton: {
        alignSelf: 'center',
        paddingVertical: 6,
        paddingHorizontal: 14,
        borderRadius: 14,
        borderWidth: 1,
        borderColor: '#F44336',
        marginBottom: 10,
    },
    reportButtonText: {
        color: '#F44336',
        fontSize: 13,
        fontWeight: '600',
    },

});

export default ProviderDetails;
